/*
 * Quem pode ver um atendimento.
 * ===========================================================
 * Espelha o filtro do backend em ListTicketsService:
 *
 *   [Op.or]: [{ userId }, { userId: null }]
 *   queueId: { [Op.or]: [effectiveQueueIds, null] }
 *
 * O backend continua sendo a autoridade — ele e quem decide o que vai
 * para a lista. Esta copia existe porque o alerta de mensagem nova chega
 * por socket, fora da listagem, e precisa tomar a mesma decisao sozinho.
 *
 * Antes o alerta tinha regra propria, muito mais frouxa: bastava o
 * atendimento nao ter dono para tocar o som em TODO mundo conectado, sem
 * olhar fila nem permissao. A pessoa ouvia o alerta, abria a tela e nao
 * encontrava nada — porque a lista, essa sim, filtrava.
 *
 * Se o filtro do backend mudar, este arquivo precisa mudar junto. Nao ha
 * como garantir isso pelo codigo; fica o aviso.
 * ===========================================================
 */

export const podeVerTodasAsFilas = user =>
  user?.profile === "admin" || user?.permissions?.["tickets.view_all"] === true;

export const podeVerTriagem = user =>
  user?.profile === "admin" || user?.permissions?.["tickets.view_triage"] === true;

/*
 * Atendimento SEM fila e visivel para todos.
 *
 * Nao e descuido: e o `null` no filtro do backend. Em triagem o cliente
 * muitas vezes ainda nao escolheu a fila, e esconder esse atendimento o
 * deixaria sem ninguem olhando.
 */
const filaVisivel = (user, ticket) => {
  if (podeVerTodasAsFilas(user)) return true;
  if (!ticket?.queueId) return true;

  const minhasFilas = (user?.queues || []).map(fila => fila.id);
  return minhasFilas.includes(ticket.queueId);
};

export const podeVerAtendimento = (user, ticket) => {
  if (!ticket) return false;

  // O que e meu eu vejo sempre, mesmo que a fila nao seja das minhas.
  if (ticket.userId && ticket.userId === user?.id) return true;

  // Atendimento de outra pessoa nao e meu problema.
  if (ticket.userId) return false;

  if (!filaVisivel(user, ticket)) return false;

  // uraActive e o que define "em triagem" (ver ListTicketsService).
  if (ticket.uraActive) return podeVerTriagem(user);

  return true;
};
